import { useNavigate, useSearchParams } from "react-router-dom";
import { cloneSearchParams, useAuth } from "@warden-ui/common";
import { parseQueryString, parseAmplifyConfig } from "@warden-ui/common";
import { composeUri } from "@warden-ui/common";
import { useEffect, useState } from "react";
import { CardContentError } from "@warden-ui/common-components";
import { CPPageBody } from "@warden-ui/common-components";

const defaultQueryString: {[key: string]: string} = {
  region: "",
  config: "",
  context: "",
  clear: "false",
}

export default function RedirectToRedirectUri() {
  const auth = useAuth();
  const [searchParams] = useSearchParams();  
  const navigate = useNavigate();
  const queryString = parseQueryString(searchParams, defaultQueryString);
  const amplifyConfig = parseAmplifyConfig(queryString);
  auth.configureAmplify(amplifyConfig);

  const [errorMessage, setErrorMessage] = useState("");

  const redirectToSignin = async () => {
    await auth.signOut(amplifyConfig);

    const params = cloneSearchParams(searchParams);
    params.set("clear", "false");
    navigate(`/?${params.toString()}`);
  }

  const redirectTo = () => {
    const redirectUri = amplifyConfig[amplifyConfig.region]?.redirectUri || import.meta.env.VITE_DEFAULT_REDIRECT_URI;
    auth.fetchAuthSession(amplifyConfig)
    .then(async (authSession) => {
      const redirectTarget = composeUri({
        baseUri: redirectUri,
        region: amplifyConfig.region,
        teamDomain: queryString.team_domain,
        authSession: authSession,
        oauthFlow: false,
      });

      console.info(`Signin success: ${authSession.userSub}`);

      window.location.replace(redirectTarget);
    });
  }

  useEffect(() => {
    let redirected = false;

    if (!redirected) redirectTo();

    return () => {
      redirected = true;
    };
  }, []);

  if (errorMessage.length > 0) {
    return (
      <CPPageBody
        onBackClicked={async () => {
          await redirectToSignin();
        }}
      >
        <CardContentError
          message={errorMessage}
        />
      </CPPageBody>
    );
  }

  // TODO: show waiting page
  return null;
}
